import { render, staticRenderFns } from "./KnSchoolInfo.vue?vue&type=template&id=5b39b4b6"
import script from "./KnSchoolInfo.vue?vue&type=script&lang=js"
export * from "./KnSchoolInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports